<template>
    <span class="ui-badge" :class="`ui-badge--${resolvedTone}`">
        <span v-if="dot" class="ui-badge__dot"></span>
        <slot>{{ resolvedText }}</slot>
    </span>
</template>

<script>
import { resolveBadge } from "./badge-statuses";

// Nomes de cor do Vuetify usados pelas telas -> tom do badge.
const COLOR_TONES = {
    primary: "primary", default: "primary", success: "success", green: "success", accent: "success",
    warning: "warning", orange: "warning", amber: "warning", "deep-orange": "warning", error: "danger", red: "danger",
    info: "info", blue: "info", indigo: "primary", purple: "purple", "deep-purple": "purple", teal: "teal", cyan: "teal",
    grey: "neutral", secondary: "neutral", "blue-grey": "neutral",
};

// Status com fundo suave e ponto colorido. Use `status` + `set` (mapa
// registrado em badge-statuses.js), `text` + `tone`, ou `text` + `color`
// (nome de cor do Vuetify, ex.: o retorno de getStatusColor()).
export default {
    name: "UiBadge",
    props: {
        status: { type: [String, Number], default: null },
        set: { type: String, default: "default" },
        text: { type: [String, Number], default: null },
        tone: { type: String, default: null },
        color: { type: String, default: null },
        dot: { type: Boolean, default: true },
    },
    computed: {
        resolved() {
            return this.status !== null ? resolveBadge(this.set, this.status) : null;
        },
        resolvedText() {
            return this.text !== null ? this.text : this.resolved ? this.resolved.text : this.status;
        },
        resolvedTone() {
            if (this.tone) return this.tone;
            if (this.color) return COLOR_TONES[String(this.color).split(" ")[0]] || "neutral";
            return this.resolved ? this.resolved.tone : "neutral";
        },
    },
};
</script>
